module.exports = __webpack_public_path__ + "static/media/p3icon.c6fc4efe.svg";